import Table from './components/table'
import BrowserCheck from './components/browser'
import Alert from './components/alert'
import Title from './components/title'
import Tabs from './components/tabs'
import { Steps, StepItem } from './components/steps/index'
import Pdf from './components/pdf/index'
import Signature from './components/signature/index'
import { Radio, RadioList } from './components/radio/index'
import { Tag, TagList } from './components/tags/index'
import Notification from './components/notification/index'
import { Transfer, TransferPanel } from './components/transfer/index'

const componentsAll = [
  Table,
  BrowserCheck,
  Alert,
  Title,
  Tabs,
  Steps,
  StepItem,
  Pdf,
  Signature,
  Radio,
  RadioList,
  Tag,
  TagList,
  Transfer,
  TransferPanel
]

const explore = {
  install(Vue) {
    for (let m of componentsAll) {
      Vue.component(m.name, m)
    }
    if (!Vue.prototype.$notification) {
      Vue.prototype.$notification = Notification
    }
  }
}

export default explore


// WEBPACK FOOTER //
// ./~/iexplore/index.js